import AdminIntegrationsComponent from "./adminIntegrations.component";

export default AdminIntegrationsComponent;
